export default {
  'file is required': 'costManagement.items.file.fileIsRequired',
  'invalid file extension': 'costManagement.items.file.invalidFileExtension',
  'file size limit is 5 MB': 'costManagement.items.file.fileSizeLimited',
  "item can't be empty": 'costManagement.items.emptyItem',
  'draft transaction with the same Fleet Task ID found':
    'costManagement.transaction.fleetTaskAlreadyExist',
  'invalid FO status': 'costManagement.transaction.invalidFOStatus',
  'template not found': 'Template tidak ditemukan.',
  'fleet task not found': 'costManagement.transaction.fleetTaskNotFound',
  transaction_date: {},

  // /transaction/:id/compare-external
  integration: {
    'unauthorized external reference': 'delivery.provider.failedToConnectAccountMsg',
  },
  external_transaction: {
    'not found': 'costManagement.transaction.dataIsDifferent',
    'data is updated externally': 'costManagement.transaction.dataIsDifferent',
  },
  transaction: {
    'business data is different': 'costManagement.transaction.dataIsDifferent',
  },
  scope: {
    'not found': '',
  },

  // /transaction/external
  external_reference: {
    unauthorized: 'delivery.provider.failedToConnectAccountMsg',
  },
  transaction_id: {
    'not found': 'costManagement.transaction.notFound',
    'already posted': 'costManagement.transaction.alreadyPosted',
    'invalid status': 'costManagement.transaction.invalidStatus',
  },
  funds_account_source: {
    empty: 'costManagement.transaction.sourceOfFundsAccountIsEmpty',
    'account number not found': 'costManagement.transaction.sourceOfFundsAccountNotFound',
    'must be cash or bank': 'costManagement.transaction.mustBeCashOrBank',
  },
  activity_chart_of_account: {
    'account number not found': 'costManagement.transaction.coaNotFound',
    invalid: 'costManagement.transaction.coaInvalid',
  },
  activity_id: {
    invalid: 'costManagement.transaction.activityInvalid',
  },
  status: {
    'not confirmed': 'costManagement.transaction.statusNotCofirmed',
  },
  license_plate: {
    'not found': 'costManagement.transaction.licensePlateNotFound',
  },
  vehicle_id: {
    invalid: 'global.text.notFound',
  },
  driver_id: {
    invalid: 'global.text.notFound',
  },
  fleet_task_id: {
    invalid: 'global.text.notFound',
  },
}
